import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GlobalProvider } from './Context/GlobalContext';
import { BrowserRouter } from 'react-router-dom';
import ChunkErrorBoundary from './Components/ChunkErrorBoundary';

// When a new build is deployed the old chunk hashes are gone from the server.
// The browser requests a stale URL, gets back HTML (404/index.html), and throws
// ChunkLoadError. Detect this and reload once to pick up the fresh chunks.
// sessionStorage guard prevents an infinite-reload loop if the chunk genuinely
// doesn't exist even after reload.
window.addEventListener('unhandledrejection', (event) => {
  const err = event?.reason;
  const isChunkError =
    err?.name === 'ChunkLoadError' ||
    err?.message?.includes('Loading chunk') ||
    err?.message?.includes('Loading CSS chunk');
  if (isChunkError) {
    const KEY = '__chunk_reload__';
    if (!sessionStorage.getItem(KEY)) {
      sessionStorage.setItem(KEY, '1');
      window.location.reload();
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ChunkErrorBoundary>

    <BrowserRouter>
      <GlobalProvider>
        {/* <React.StrictMode> */}
        <App />
        {/* </React.StrictMode> */}
      </GlobalProvider>
    </BrowserRouter>
  </ChunkErrorBoundary>

);

reportWebVitals();
